import React, { useEffect, useState } from "react";
import { api } from "@/lib/kielo";
import { useI18n } from "@/i18n";
import { ChevronDown, BookOpen } from "lucide-react";

export default function Grammar() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/grammar", { params: { lang } }).then(({ data }) => setItems(data));
  }, [lang]);

  const levels = ["A1", "A2"];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-testid="grammar-page">
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#0E382B] tracking-tight">{t("grammarPage.title")}</h1>
      <p className="mt-2 text-[#52635B] text-base">{t("grammarPage.sub")}</p>

      {!items.length ? (
        <p className="mt-10 text-[#52635B]">{t("common.loading")}</p>
      ) : (
        levels.map((lvl) => (
          <div key={lvl} className="mt-8">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-[#8A5A1E] mb-3">{lvl === "A1" ? "Level A1" : "Level A2"}</h2>
            <div className="space-y-3">
              {items.filter((g) => g.level === lvl).map((g) => {
                const isOpen = open === g.id;
                return (
                  <div key={g.id} data-testid={`grammar-item-${g.id}`} className="rounded-2xl bg-white border border-[#E9E6DF] overflow-hidden">
                    <button
                      onClick={() => setOpen(isOpen ? null : g.id)}
                      data-testid={`grammar-toggle-${g.id}`}
                      className="w-full flex items-center gap-3 px-5 py-4 text-left"
                    >
                      <span className="w-9 h-9 rounded-xl bg-[#E6ECFA] text-[#1E429F] flex items-center justify-center shrink-0">
                        <BookOpen className="w-4 h-4" />
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block font-serif text-lg font-semibold text-[#0E382B]">{g.title}</span>
                        <span className="block text-sm text-[#52635B] truncate">{g.summary}</span>
                      </span>
                      <ChevronDown className={`w-5 h-5 text-[#B5B0A2] transition-transform ${isOpen ? "rotate-180" : ""}`} />
                    </button>
                    {isOpen && (
                      <ul className="px-5 pb-5 pt-1 space-y-2">
                        {g.points.map((p, i) => (
                          <li key={i} className="flex gap-2.5 text-[#3E4B45] text-[15px]">
                            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#E46A28] shrink-0" />
                            <span>{p}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
